import React from 'react';
import SaveVPCSheet from 'components/checkoutModals/SaveVPCSheet';
import BookAppointmentSheet from 'components/BookAppointmentSheet/BookAppointmentSheet';
import UnsavedChangesSheet from 'components/UnsavedChangedModal/UnsavedChangesSheet';
import LoadVPCSheet from 'components/LoadVPCSheet/LoadVPCSheet';
import MobileFiltersSheet from 'components/MobileFiltersSheet/MobileFiltersSheet';
import StoreSelectorSheet from 'components/StoreSelectorSheet/StoreSelectorSheet';
import { genericMode, rangeIsPax } from 'utils/queryUtils';
import AvailabilitySheet from 'components/AvailablilitySheet/AvailablilitySheet';
import { isIkeaApp, isMobile, isWeb } from 'utils/platform';
import ProductDetailsSheet from 'components/ProductSidebar/ProductDetails/ProductDetailsSheet';
import { useNavigationBlock } from 'contexts/navigationBlock';
import PrintQuestionSheet from 'components/PrintQuestionSheet/PrintQuestionSheet';
import PrintOptionsSheet from 'components/PrintOptionsSheet/PrintOptionsSheet';
import SlidingDoorsInfoSheet from 'components/SlidingDoorsInfoSheet/SlidingDoorsInfoSheet';
import UnavailableFramesMenu from 'components/ProductSidebar/menus/UnavailableFramesMenu/UnavailableFramesMenu';
import UnavailableProductsMenu from 'components/ProductSidebar/menus/UnavailableProductsMenu/UnavailableProductsMenu';
import QuestionSheet from 'components/QuestionSheet/QuestionSheet';
import FrontStyleSheet from 'components/FrontStyleSheet/FrontStyleSheet';
import CantOpenDesignModal from 'components/CantOpenDesignModal/CantOpenDesignModal';
import ResumeLastSessionModal from 'components/ResumeLastSessionModal';
import SaveDesignToProfile from 'components/SaveDesignToProfile/SaveDesignToProfile';
import OpenDesignFromProfile from 'components/OpenDesignFromProfile/OpenDesignFromProfile';
import ShareDesignCard from 'components/ShareDesignCard/ShareDesignCard';
import { useServiceSettings } from 'contexts/serviceSettings';

const Sheets = () => {
  const { enableSaveToProfile } = useServiceSettings().dexfSettings.general;
  const { prompt: Prompt } = useNavigationBlock();

  return (
    <>
      <Prompt />
      <SaveVPCSheet />
      <LoadVPCSheet />
      <UnsavedChangesSheet />
      <CantOpenDesignModal />
      <BookAppointmentSheet />
      {isWeb() && <PrintQuestionSheet />}
      <PrintOptionsSheet />
      {!isIkeaApp() && <AvailabilitySheet />}
      <ProductDetailsSheet />
      {!isIkeaApp() && <StoreSelectorSheet />}
      <SlidingDoorsInfoSheet />
      <UnavailableProductsMenu />
      <QuestionSheet />
      <FrontStyleSheet />
      <ResumeLastSessionModal />
      <ShareDesignCard />
      {enableSaveToProfile && <SaveDesignToProfile />}
      {enableSaveToProfile && <OpenDesignFromProfile />}
      {!genericMode() && rangeIsPax() && <UnavailableFramesMenu />}
      {isMobile() && <MobileFiltersSheet />}
    </>
  );
};

export default Sheets;
